import * as Sentry from '@sentry/react'
import { isDevelopment, productionHostnames, stagingHostnames } from '../shared/platform'
import { AppError } from '~/prix'
import publicConfig from './publicConfig'

export default function initErrorReporting() {
  const dsn = publicConfig().services.sentry?.dsn
  if (dsn == null || dsn === '') {
    return
  }

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: stagingHostnames.includes(window.location.hostname)
      ? 'staging'
      : productionHostnames.includes(window.location.hostname)
        ? 'production'
        : 'development',

    enabled: isDevelopment === false,

    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    tracePropagationTargets: ['localhost'],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    // Attach information to Sentry events
    beforeSend: (event, hint) => {
      const error = hint.originalException
      if ((error as AppError).isAppError) {
        event.extra = {
          ...event.extra,
          key: (error as AppError).key,
          code: (error as AppError).code,
          payload: (error as AppError).payload,
          autoRetry: (error as AppError).autoRetry,
          originalErrorMessage: (error as AppError).originalError
            ? (error as AppError).originalError?.message
            : null,
          originalErrorStack: (error as AppError).originalError
            ? (error as AppError).originalError?.stack
            : null,
        }
      }
      return event
    },
  })
}
